import React, { useEffect, useMemo, useState } from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select'
import { constructOptions } from '../../Utils/helper';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { addMember, getAddType, getAllClients, getProvider, gettingDetail, updateMember } from '../../Redux/Actions/DashOptions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Common/Loader';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const AddMember = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null); // State to handle selected file

    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data) // get provider data for listing
    const getListingLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading of provider
    const getDataType = useSelector((state) => state?.DashOptionsSlice?.getTypeData?.data)   // get type data for listing
    const getDataTypeLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)   // get listing laosing of type
    const clientData = useSelector((state) => state?.DashOptionsSlice?.allClients?.data) // client list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading

    const getMemberDetails = useSelector((state) => state?.DashOptionsSlice?.detailOfMember) // individual member detail

    const options = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Discharge' },
    ]

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        console.log(file)
        if (file) {
            setSelectedFile(URL.createObjectURL(file));
            toast.success(`File "${file.name}" selected for upload.`);
            // Here you can dispatch an action to upload the file if needed, e.g., dispatch(uploadMemberFile({ id, file }));
        }
    };

    const handleSubmit = (values, form) => {
        const transformedMonths = (values.monthforfile || []).map((dateObj) => ({
            month: dateObj.format("MMMM"),
            year: dateObj.year
        }));

        const payload = {
            name: values.name, 
            member_id: values.MemberID, 
            ssn: values.socialSecurityNumber, 
            dob: values.dob,
            start_date: values.authStartDate, 
            last_cover_date: values.lastCoveredDate, 
            provider: values.provider?.value,
            type: values?.memberType?.value, 
            status: values?.status?.value, 
            client_id: values.client?.value, 
            filing_months: transformedMonths
        }
        
        if (!id) {
            dispatch(addMember(payload)).then((res) => {
                if (res?.payload?.id) {
                    toast.success('Successfully added')
                    // If file is selected, you can upload it here after member creation
                    if (selectedFile) {
                        // Example: dispatch(uploadMemberFile({ memberId: res.payload.id, file: selectedFile }));
                    }
                    navigate('/dashboard/memberlisting')
                } else {
                    toast.error('An error occured' || res?.message)
                }
                form.reset()
            })
        } else {
            dispatch(updateMember({ id: getMemberDetails?.id, payload })).then((res) => {
                if (res?.payload?.id) {
                    toast.success('Successfully updated')
                    // If file is selected, upload it here
                    if (selectedFile) {
                        // Example: dispatch(uploadMemberFile({ memberId: getMemberDetails.id, file: selectedFile }));
                    }
                } else {
                    toast.error('An error occured')
                }
                form.reset()
                navigate('/dashboard/memberlisting')
            })
        }
    };

    const handleBack = (e) => {
        e.preventDefault()
        if (id) {
            navigate("/dashboard/memberlisting")
        } else {
            navigate("/dashboard");
        }
    };

    const validate = (values) => {
        const error = {};
        if (!values.name) {
            error.name = "Required"
        }
        if (!values.dob) {
            error.dob = "Required"
        }
        if (!values.socialSecurityNumber) {
            error.socialSecurityNumber = "Required"
        } else if (!/^\d{9}$/.test(values.socialSecurityNumber.replace(/-/g, ''))) {
            error.socialSecurityNumber = "SSN must be exactly 9 digits";
        }
        if (!values.client) {
            error.client = "Required"
        }
        if (!values.provider) {
            error.provider = "Required"
        }
        if (!values.memberType) {
            error.memberType = "Required"
        }
        if (!values.MemberID) {
            error.MemberID = "Required"
        }
        if (!values.authStartDate) {
            error.authStartDate = "Required"
        }

        return error
    }

    const initialValues = useMemo(() => {
        if (id && getMemberDetails) {
            return {
                name: getMemberDetails?.name,
                dob: getMemberDetails?.dob,
                memberType: { value: getMemberDetails?.type?.id, label: getMemberDetails?.type?.name },
                client: { value: getMemberDetails?.client?.id, label: getMemberDetails?.client?.name },
                provider: { value: getMemberDetails?.provider?.id, label: getMemberDetails?.provider?.name },
                socialSecurityNumber: getMemberDetails?.ssn,
                MemberID: getMemberDetails?.member_id,
                authStartDate: getMemberDetails?.start_date,
                lastCoveredDate: getMemberDetails?.last_cover_date,
                status: { value: getMemberDetails?.status, label: getMemberDetails?.status }
            }
        } 
        return {
            name: '',
            dob: '',
            memberType: '',
            client: '',
            provider: '',
            socialSecurityNumber: '',
            MemberID: '',
            authStartDate: '',
            lastCoveredDate: '',
            monthforfile: '',
            status: ''
        }
    }, [getMemberDetails, id]);

    useEffect(() => {
        dispatch(getProvider())
        dispatch(getAddType())
        dispatch(getAllClients())
        if (id) {
            setLoading(true)
            dispatch(gettingDetail(id)).then((res) => setLoading(false))
        }
    }, [id, dispatch])

    const maxSelectableDate = new Date();
    maxSelectableDate.setDate(0);

    // Show upload button only for Add New Member (!id)
    const showUploadButton = !id;

    return (
        <div className="flex justify-center items-center py-2 sm:px-6 lg:px-8 bg-gray-50 min-h-screen">
            {loading && <Loader />}
            <div className="bg-white shadow-2xl border border-gray-100 rounded-xl px-10 py-8 w-full max-w-5xl">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-3xl font-bold text-indigo-700">{id ? 'Update Member' : 'Add New Member'}</h2>
                    
                </div>
                <Form
                    initialValues={initialValues}
                    validate={validate}
                    onSubmit={handleSubmit}
                    render={({ handleSubmit, valid }) => (
                        <form onSubmit={(e) => {
                            if (!valid) {
                                toast.error('Please fill all the mandatory fields')
                            }
                            handleSubmit(e)
                        }} className="space-y-5">
                            <div className="grid grid-cols-2 gap-4">
                                <Field name="name">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Full Name
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Enter Name"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="dob">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Date of Birth
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>

                                <Field name="socialSecurityNumber">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Social Security Number(SSN)
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Social Security Number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                            {meta.touched && meta.error && (
                                                <span className='text-red-500 text-base font-bold ml-1'>
                                                    {meta.error === "SSN must be exactly 9 digits" ? meta.error : ""}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </Field>
                                <Field name="client">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Client
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select Provider"
                                                options={constructOptions(
                                                    clientData?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={clientListLoading}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="provider">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Provider
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select Provider"
                                                options={constructOptions(
                                                    getProviderData?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={getListingLoading}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="memberType">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Type
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select Type"
                                                options={constructOptions(
                                                    getDataType?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="MemberID">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Member ID
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Member ID"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="authStartDate">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Start Date
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="lastCoveredDate">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Last Covered Date
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="monthforfile">
                                    {({ input, meta }) => (
                                        <div className='relative'>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Select months for filling
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <div className="absolute top-9 right-2 text-black-600 text-sm z-10">
                                                <FontAwesomeIcon icon={faCalendarAlt} className="text-xl" />
                                            </div>
                                            <DatePicker
                                                {...input}
                                                onlyMonthPicker
                                                multiple
                                                sort
                                                value={input.value}
                                                onChange={(val) => input.onChange(val)}
                                                format="MMMM YYYY"
                                                plugins={[<DatePanel key="date-panel" />]}
                                                inputClass="custom-input"
                                                placeholder="Select months"
                                                maxDate={maxSelectableDate}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="status">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Status
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select Status"
                                                options={options}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={getDataTypeLoading}
                                            />
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className="flex justify-end gap-4 pt-6">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="px-5 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                                >
                                    Back
                                </button>
                                <button
                                    type="submit"
                                    className="px-6 py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md shadow transition"
                                >
                                    {id ? "Update" : 'Submit'}
                                </button>
                            </div>
                        </form>
                    )}
                />
            </div>
            {selectedFile && (
<div className="mt-4">
<img
src={selectedFile }
alt="Preview"
className="w-40 h-40 object-cover rounded-lg shadow-md border"
/>
</div>
)}
        </div>
        
    );
};

export default AddMember;